// Renderer-owned full-color SVG symbols. Packages select IDs only: they cannot
// supply SVG markup, paths, external references, scripts or URLs.
export interface ColorIconPart { d: string; fill: string; stroke?: string; width?: number }
export const COLOR_ICONS: Record<string, ColorIconPart[]> = {
  twig: [
    { d: 'M4 21L19 4M10 15L7 8M14 11L20 12', fill: 'none', stroke: '#764323', width: 4 },
    { d: 'M5 20L19 5M10 14L8 8', fill: 'none', stroke: '#c68b49', width: 1.4 },
  ],
  resin: [
    { d: 'M12 2C8 8 5 11 5 15a7 7 0 0 0 14 0C19 11 16 8 12 2Z', fill: '#e3a221', stroke: '#8d541e', width: 1 },
    { d: 'M10 9C7 13 7 16 10 18', fill: 'none', stroke: '#ffdf87', width: 2 },
  ],
  pebble: [
    { d: 'M4 10L9 4H17L21 11L19 19L10 22L3 17Z', fill: '#6f7d85', stroke: '#39464c', width: 1 },
    { d: 'M9 4L16 7L10 14L4 10Z', fill: '#c8d1d3' }, { d: 'M10 14L19 19L10 22L3 17Z', fill: '#8e9da5' },
  ],
  berry: [
    { d: 'M12 8C8 7 4 11 4 16a8 7 0 0 0 16 0C20 11 16 7 12 8Z', fill: '#c84050', stroke: '#7a2234', width: 1 },
    { d: 'M11 8C9 3 4 3 4 3C4 7 8 9 11 8ZM12 8C12 2 18 2 20 3C18 7 15 9 12 8Z', fill: '#4f8439' },
    { d: 'M8 12L7 16', fill: 'none', stroke: '#f5969a', width: 2 },
  ],
  point: [
    { d: 'M12 2L15 8L22 9L17 14L18 22L12 18L6 22L7 14L2 9L9 8Z', fill: '#efc84e', stroke: '#93601f', width: 1 },
    { d: 'M12 4L12 15L5 10L10 9Z', fill: '#fff2a1' },
  ],
  card: [
    { d: 'M3 3H17V20H3Z', fill: '#e3d6b4', stroke: '#6a4d31', width: 1 },
    { d: 'M7 5H21V23H7Z', fill: '#fff2d8', stroke: '#6a4d31', width: 1 },
    { d: 'M10 8H18V16H10Z', fill: '#64947c' }, { d: 'M10 19H18', fill: 'none', stroke: '#6a4d31', width: 1 },
  ],
  worker: [
    { d: 'M12 2a4 4 0 1 0 0 8a4 4 0 1 0 0-8ZM8 10L4 15L7 18L5 23H19L17 18L20 15L16 10Z', fill: '#b46e3a', stroke: '#693d24', width: 1 },
    { d: 'M10 3L9 7M9 13L7 16', fill: 'none', stroke: '#e3ad68', width: 1.5 },
  ],
  wild: [
    { d: 'M12 2L22 12L12 22L2 12Z', fill: '#f5e5b9', stroke: '#6a4d31', width: 1 },
    { d: 'M12 4L12 12L4 12Z', fill: '#cd6250' }, { d: 'M12 4L20 12H12Z', fill: '#e8b942' },
    { d: 'M20 12L12 20V12Z', fill: '#6788a1' }, { d: 'M12 20L4 12H12Z', fill: '#659251' },
  ],
};
